<template>
  <div id="user-management">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Tryout</li>
      <li class="active">Tryout Regrading</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">List Tryout Participants</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading" style="display:flex; justify-content:space-between; align-items:center;">
            <div style="width:50%;">
              Daftar Partisipan
            </div>
            <div>
              <!-- <button class="btn btn-success" style="padding:5px; font-size: 11px;" @click="$router.push('/organizations/form')">Buat Organisasi</button> -->
            </div>
          </div>
          <div class="panel-body">
            <div class="searchbox" style="width:100%;">
              <div class="row">
                  <div class="col-md-3">
                  <label>Start Date*</label>
                  <div class="form-group">
                    <transition name="fade">
                      <div class="input-group">
                        <input
                          id="filterStart"
                          
                          type="text"
                          class="form-control datepicker"
                          name="discussion_date"
                          readonly
                          style="color: black !important;background: white !important;"
                        />
                        <span class="input-group-btn">
                          <button class="btn btn-success" type="button">
                            <i class="fa fa-calendar"></i>
                          </button>
                        </span>
                      </div>
                    </transition>
                  </div>
                </div>
                <div class="col-md-4">
                  <label>End Date*</label>
                  <div class="form-group">
                    <transition name="fade">
                      <div class="col-md-12 col-xs-12" style="display:flex; ">
                        <div class="input-group">
                          <input
                            id="filterEnd"
                            
                            type="text"
                            class="form-control datepicker"
                            name="discussion_date"
                            style="color: black !important;background: white !important;"
                            readonly
                          />
                          <span class="input-group-btn">
                            <button class="btn btn-success" type="button">
                              <i class="fa fa-calendar"></i>
                            </button>
                          </span>
                        </div>
                        <select class="form-control" v-model="filter.state" style="width:100px; margin-left: 10px;">
                          <option value="FINISHED">FINISHED</option>
                          <option value="STARTED">STARTED</option>
                        </select>
                        <button class="btn btn-success" style="padding:5px; font-size: 14px; margin-left:10px;" @click="loadOrganizationsData(1)">Apply</button>
                      </div>
                    </transition>
                  </div>
                </div>

              </div>
            </div>
            
            <div class="row">
              <div class="col-md-12 text-left">
                  <button :disabled="filter.start_date == null && filter.end_date == null && organizations.length == 0" class="btn btn-success" style="padding:5px; margin-right: 15px;" @click="showConfirmationModal = true">Grading Ulang</button>
                  <span style="font-size:15px; color:black; font-weight:bold;">Total Item: {{ totalItem }}</span>
              </div>
            </div>
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Nama Siswa</th>
                  <th>Email</th>
                  <th>Nama Tryout</th>
                  <th>Tanggal Mulai</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(organization, key) in organizations" v-bind:key="key">
                  <td>{{ (25 * (pageNumber - 1)) + (key + 1) }}</td>
                  <td>{{ organization.name }}</td>
                  <td>{{  organization.email }}</td>
                  <td>{{ organization.tryout.name }}</td>
                  <td>{{ organization.created_at | convertDate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="panel-footer">
            <div class="btn-group" style="display:flex; align-items:center;">
              <button class="btn btn-white" :disabled="pageNumber === 1" type="button" @click="loadOrganizationsData(--pageNumber)">
                Previous
              </button>
              <!-- <p>{{ pageNumber }} / {{ total_page }} </p> -->
              <input type="text" class="form-control" :value="pageNumber + ' / ' + total_page" style="width: 80px; text-align: center">
              <button class="btn btn-white" :disabled="pageNumber === total_page" type="button" @click="loadOrganizationsData(++pageNumber)">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
    <app-modal :withCancel="true" v-if="showConfirmationModal" v-on:cancel="showConfirmationModal=false" v-on:ok="submitRegrading()">
    <h3 slot="header">Konfirmasi</h3>
    <div slot="body">Apakah ada yakin akan regrading untuk  <strong style="color: red">{{totalItem}} siswa ?</strong></div>
  </app-modal>
  </div>
</template>
<script>
import axios from 'axios'
import AppSpinner from '@/components/plugins/Spinner'
import DataTable from '@/components/plugins/DataTable'
import moment from "moment";
import Modal from '@/components/plugins/Modal'

export default {
  name: 'user-management',
  components: {
    'app-spinner': AppSpinner,
    'app-modal': Modal,
    'app-datatable': DataTable
  },
  data: function () {
    return {
      query: '',
      isLoading: false,
      pageNumber: 1,
      organizations: [],
      total_page: 0,
      isDisabledNextBtn: false,
      totalItem: 0,
      showConfirmationModal: false,
      filter: {
          start_date: null,
          end_date: null,
          state: 'STARTED'
      }
    }
  },
  watch: {
    pageNumber: function(newVal) {
      this.loadOrganizationsData(newVal)
    },
  },
  filters: {
      convertDate(v) {
          return moment(v).format("DD MMMM YYYY");
      }
  },
  methods: {
    loadOrganizationsData: function (pageNumber = 1) {
      var context = this
      var token = this.$ls.get('token');
      var filterstate = ''
      if(context.filter.state === 'STARTED') filterstate = '&state=STARTED&is_ended=true'
      else filterstate = '&state=FINISHED'
      var url = process.env.API_BASE_URL + '/tryout-service/tryout/participants?page='+pageNumber+'&page_size=25' + filterstate + '&started_at='+moment(context.filter.start_date + ' 00:00:01', 'DD/MM/YYYY HH:mm:ss').valueOf()+'&ended_at=' + moment(context.filter.end_date + " 23:59:59", 'DD/MM/YYYY HH:mm:ss').valueOf()

      this.isLoading = true
      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })

      http.get(url, {
        params: {
          page: pageNumber,
          // name: this.query
        }
      })
      .then(function(response) {
          // console.log(response)
        if (response.data.length < 25) {
          context.isDisabledNextBtn = true
        } else {
          context.isDisabledNextBtn = false
        }
        context.organizations = response.data.data
        context.total_page = response.data.total_page
      //   console.log(context.total_page)
        context.totalItem = response.data.total_item
        context.isLoading = false
      })
      .catch(function (error) {
        console.log(error.message)
      })
      .then(function() {
        context.isLoading = false
      })
    },
    submitRegrading(){
      var context = this
      var data = this.data
      var token = this.$ls.get('token');
      this.isLoading = true
      var filterstate = ''
      if(context.filter.state === 'STARTED') filterstate = 'state=STARTED&is_ended=true'
      else filterstate = 'state=FINISHED'
      var url = process.env.API_BASE_URL + '/tryout-service/tryout/participants/grading?' + filterstate + '&started_at='+moment(context.filter.start_date + ' 00:00:01', 'DD/MM/YYYY HH:mm:ss').valueOf()+'&ended_at=' + moment(context.filter.end_date + ' 23:59:59', 'DD/MM/YYYY HH:mm:ss').valueOf()

      var http = axios.create({
          headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
          }
      })
      // if (this.validateForm()) {
          http.post(url, data)
          .then((response) => {
              context.isLoading = false
              context.loadOrganizationsData(1)
              context.showConfirmationModal = false
              // context.$router.push('/organizations')
          })
          .catch((error) => {
              context.isLoading = false
              context.showConfirmationModal = false
              alert("Gagal grading data : " + error.response.data.message)
          })
      // }
    },
    goToDetail: function(id) {
      this.$router.push('organization/' + id)
    }
  },
  mounted: function () {
  // this.loadOrganizationsData()
  let context = this
  DatepickerPlugin.init("#filterStart", function (value) {
      context.filter.start_date = value;
  });
  DatepickerPlugin.init("#filterEnd", function (value) {
      context.filter.end_date = value;
  });
  }
}
</script>




// WEBPACK FOOTER //
// Regrading.vue?fa482618